const initVariationModal = () => {
  jQuery('.js-toggle-purchase-modal').on('click', function () {
    jQuery('.js-purchase-modal').addClass('is-open')
    jQuery('.c-price-box').addClass('is-active')
    jQuery('.c-nav--bottom').addClass('is-disabled')
  })

  jQuery('.c-modal__close').on('click', function () {
    jQuery('.js-purchase-modal').removeClass('is-open')
    jQuery('.c-price-box').removeClass('is-active')
    jQuery('.c-nav--bottom').removeClass('is-disabled')
  })
}

export {initVariationModal}